var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("fieldset", { staticClass: "c-icon-list" }, [
      _c("legend", { staticClass: "visually-hidden" }, [
        _vm._v(_vm._s(_vm.title))
      ]),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "c-icon-list__group", attrs: { role: "radiogroup" } },
        _vm._l(_vm.items, function(item, index) {
          return _c("li", { key: index, staticClass: "c-icon-list__item" }, [
            _c("input", {
              staticClass: "c-icon-list__input",
              attrs: {
                name: _vm.title,
                type: "radio",
                id: _vm.name + "-" + index
              },
              on: {
                change: function($event) {
                  return _vm.handleCheckBoxChange(item.title)
                }
              }
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "c-icon-list__label",
                attrs: { for: _vm.name + "-" + index }
              },
              [
                item.icon
                  ? _c("span", { staticClass: "c-icon-list__icon" }, [
                      _c(
                        "svg",
                        {
                          staticClass: "c-icon-list__icon-svg",
                          attrs: { "aria-hidden": "true", focusable: "false" }
                        },
                        [
                          _c("use", {
                            attrs: {
                              "xmlns:xlink": "http://www.w3.org/1999/xlink",
                              "xlink:href": "#" + item.icon
                            }
                          })
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v("\n          " + _vm._s(item.title))
              ]
            )
          ])
        }),
        0
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "c-icon-list__actions" }, [
      _c(
        "button",
        {
          staticClass: "c-button c-button--brand c-icon-list__button",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              return _vm.setCurrentPanel()
            }
          }
        },
        [_vm._v("\n      Back\n    ")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "c-button c-button--brand c-icon-list__button",
          attrs: { type: "button", disabled: !_vm.selectedPanel },
          on: { click: _vm.handleNextButton }
        },
        [_vm._v("\n      Next\n    ")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1103bf4b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1103bf4b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/consumer/contact-us/_vue/IconList.vue
// module id = 716
// module chunks = 0